import React, { FC, useEffect, useRef } from 'react';
import { SearchInputSmall } from '../common/SearchInputSmall';
import { useDebounce } from 'use-debounce';
import { NumberFilterComponent } from '../filter/TextFilterComponent';
import { FilterComponent } from '../FilterComponent';
import { useLocation } from 'react-router';
import { useNavigate } from 'react-router-dom';
import { makeSearchParams, parseSearchParams } from '../../utils/utilities';
// import { IModalWindow, ModalWindow } from '../../../_flexCharge/partials/widgets/modal/ModalWindow';
// import { AddContactModal } from './AddContactModal';
// import { IContact } from '../../store/contacts/contacts-interfaces';

export interface IContactsFilter {
	email?: string;
	userId?: string;
	query?: string;
	pageSize?: string;
	pageNumber?: string;
}

interface Props {
	query?: string;
	email?: string;
	userId?: string;
	setQuery: (query: string) => void;
	setEmail: (email: string) => void;
	setUserId: (userId: string) => void;

}

export const ContactsFilter: FC<Props> = (props) => {

	const { query, email, userId, setQuery, setEmail, setUserId } = props;

	const emailRef = useRef(null);
	const userIdRef = useRef(null);
	const isMounted = useRef(false);
	const { pathname, search } = useLocation();
	const navigate = useNavigate();

	const [value] = useDebounce(query.trim(), 1000);

	const filtersFromUrl: IContactsFilter = parseSearchParams(search) || {};

	// const [isModalOpen, setIsModalOpen] = useState<boolean>(false);
	// const [modalState, setModalState] = useState<IModalWindow>({
	// 	isOpen: false
	// });
	//
	// const closeModal = (): void => setModalState(prevState => ({ ...prevState, isOpen: false }));

	// const handleSuccess = (): void => {
	// 	setIsModalOpen(false);
	// 	setChosenContact(null);
	// 	setModalState({
	// 		isOpen: true,
	// 		modalTitle: 'Add contact',
	// 		content: (
	// 			<div className="fs-6">
	// 				Contact was successfully saved
	// 			</div>
	// 		),
	// 		confirmButtonText: 'Ok',
	// 		minHeight: 100,
	// 		onConfirm: () => setModalState(prevState => ({ ...prevState, isOpen: false })),
	// 		onClose: closeModal
	// 	});
	// };
	//
	// const handleError = (): void => {
	// 	setIsModalOpen(false);
	// 	setModalState({
	// 		isOpen: true,
	// 		modalTitle: 'Add contact',
	// 		content: (
	// 			<div className="fs-6">
	// 				Failed saving contact
	// 			</div>
	// 		),
	// 		confirmButtonText: 'Try again',
	// 		minHeight: 100,
	// 		onConfirm: () => {
	// 			setModalState(prevState => ({ ...prevState, isOpen: false }));
	// 			setIsModalOpen(true);
	// 		},
	// 		onClose: closeModal
	// 	});
	// };

	useEffect(() => {
		if (!isMounted.current) return;

		const params: IContactsFilter = { ...filtersFromUrl };
		params.email = email;
		params.userId = userId;
		params.query = query;

		navigate(`${pathname}?${makeSearchParams(params)}`);
	}, [value, email, userId]);

	useEffect(() => {
		if (!isMounted.current) {
			// first mount
			isMounted.current = true;
		}
	}, []);

	return (
		<div className="card bg-transparent">
			<div className="d-sm-flex justify-content-between align-items-center mb-5">
				<div className="d-flex align-items-center block-width application-selector">
					<SearchInputSmall
						placeholder="Search contact"
						additionalClass=""
						searchValue={query}
						setSearchValue={setQuery}
					/>
				</div>
				{/*<div className="mt-5 mt-sm-0">*/}
				{/*	<ButtonComponent*/}
				{/*		buttonName="Add contact"*/}
				{/*		onButtonClick={(): void => setIsModalOpen(true)}*/}
				{/*		additionalClass="w-100 btn-sm w-sm-120px"*/}
				{/*	/>*/}
				{/*</div>*/}
			</div>
			<div className="d-flex align-items-center  fc-filter-line">
				<FilterComponent value={email} label="Email" labelPlacement="integrated">
					<NumberFilterComponent
						reference={emailRef}
						fieldLabel='Email'
						close={(): void => emailRef.current.close()}
						open={(): void => emailRef.current.open()}
						value={email}
						setValue={setEmail}
						type="text"
						isEmail
					/>
				</FilterComponent>
				<FilterComponent value={userId} label="User Id" labelPlacement="integrated">
					<NumberFilterComponent
						reference={userIdRef}
						fieldLabel='User Id'
						close={(): void => userIdRef.current.close()}
						open={(): void => userIdRef.current.open()}
						value={userId}
						setValue={setUserId}
						type="text"
						isGuid
					/>
				</FilterComponent>
			</div>
			{/*<ModalWindow*/}
			{/*	{...modalState}*/}
			{/*	onClose={closeModal}*/}
			{/*/>*/}

			{/*<ModalWindow*/}
			{/*	isOpen={isModalOpen}*/}
			{/*	modalTitle="Add contact"*/}
			{/*	onClose={():void => setIsModalOpen(false)}*/}
			{/*	backdrop="static"*/}
			{/*	content={*/}
			{/*		<AddContactModal*/}
			{/*			onSuccess={handleSuccess}*/}
			{/*			onError={handleError}*/}
			{/*			chosenContact={chosenContact}*/}
			{/*		/>*/}
			{/*	}*/}
			{/*/>*/}
		</div>
	);
};
